var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 18.4641C7.70833 16.9245 7.70833 13.0755 10.375 11.5359L20.875 5.47372C23.5417 3.93412 26.875 5.85863 26.875 8.93783L26.875 21.0622C26.875 24.1414 23.5417 26.0659 20.875 24.5263L10.375 18.4641Z",
    fill: "#36ACD6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 26.875,
    width: 3.75,
    height: 23.75,
    rx: 1.875,
    transform: "rotate(180 3.75 26.875)",
    fill: "#36ACD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFive);
export default __webpack_public_path__ + "static/media/Five.9b9896077e81ed3a98e6af725c9153d0.svg";
export { ForwardRef as ReactComponent };